import React from "react";
import { DemandeLayout } from "../shared/DemandeLayout";
import { TitreCultureNotice } from "./TitreCultureNotice";
import { FormulaireTitreCulture } from "./FormulaireTitreCulture";

export const DemandeTitreCulture = () => {

  const LIBELLE_TITRE_CULTURE="TITRES CULTURE";

  return (
    <DemandeLayout Notice={TitreCultureNotice} Formulaire={FormulaireTitreCulture} libellePrestation={LIBELLE_TITRE_CULTURE}/>
  );
};
